import { FAQApiRequest, UpdateFAQRequest } from '@/data/payload/api/FAQRequest'
import {
  PostFAQInterface,
  UpdateFAQInterface,
  DeleteFAQInterface,
} from '@/data/payload/contracts/FAQRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { FAQDataMapper } from '@/data/persistences/mappers/FAQDataMapper'
import { FAQRepositoryInterface } from '@/data/persistences/repositories/contracts/FAQRepositoryInterface'
import { FAQ } from '@/domain/entities/Faq'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class FAQApiRepository implements FAQRepositoryInterface {
  private service: ApiService
  private mapper: FAQDataMapper

  constructor(service: ApiService, mapper: FAQDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(payload: DeleteFAQInterface): Promise<FAQ> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.FAQ_DELETE,
      undefined,
      payload as FAQApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostFAQInterface): Promise<FAQ> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.FAQ,
      undefined,
      payload as FAQApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(payload: UpdateFAQInterface, id: number): Promise<FAQ> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.FAQ}/${id}`,
      undefined,
      payload as UpdateFAQRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<FAQ> {
    const resp = await this.service.invoke('get', Endpoints.Route.FAQ, params)
    return this.mapper.convertFAQFromApi(resp)
  }
}
